import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bf37c89&scoped=true"
import script from "./accountingDetails.js?vue&type=script&lang=js&external"
export * from "./accountingDetails.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=2bf37c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf37c89",
  null
  
)

export default component.exports